import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { global } from './api.global';
import { Users } from '../../models/pos.models/usuario'

@Injectable(
	{
		providedIn: 'root'
	}
)

export class UserService{
	public url: string;
	public identity;
	public token;
	
	constructor(public _http: HttpClient){
		this.url = global.url;
	}

	//--Registrar Usuario--//
	register(token, user): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type','application/json')
										.set('Authorization', token);

		return this._http.post(this.url+'usr_register', user, {headers: headers});
	}

	//--Validar usuario administrador--//
	adminUser(user): Observable<any>{
		let json = JSON.stringify(user);
		let headers = new HttpHeaders().set('Content-Type','application/json');

		return this._http.post(this.url+'usr_usradmin', json, {headers: headers});
	}

	//Obtner el token o los datos decodificados del usuario
	signup(user, gettoken = null): Observable<any>{
		if(gettoken != null){
			user.gettoken = 'true';
		}
		let jsonu = JSON.stringify(user);
		let headers = new HttpHeaders().set('Content-Type','application/json');

		return this._http.post(this.url+'usr_login', jsonu, {headers: headers});
	}

	//--Actualizar registro de usuario--//
	update(token, user): Observable<any>{
		let json = JSON.stringify(user);
		let headers = new HttpHeaders().set('Content-Type','application/json')
										.set('Authorization', token);

		return this._http.put(this.url+'usr_update', json, {headers: headers});
	}
	//--Activar nuevo usuario--
	activusr(user): Observable<any>{
		let json = JSON.stringify(user);
		let headers = new HttpHeaders().set('Content-Type','application/json');
										
		return this._http.put(this.url+'usr_activusr', json, {headers: headers});
	}

	//--Restablecer contraseña
	resetPassw(user): Observable<any>{
		let json = JSON.stringify(user);
		let headers = new HttpHeaders().set('Content-Type','application/json');

		return this._http.put(this.url+'usr_forgpsw', json, {headers: headers});
	}

	//--Restablecer contraseña con codigo enviado por email
	resetPasswCd(user): Observable<any>{
		let json = JSON.stringify(user);
		let headers = new HttpHeaders().set('Content-Type','application/json');

		return this._http.put(this.url+'usr_rspasscode', json, {headers: headers});
	}

	//--Actualizar imagen de perfil de Usuario--//
	upImage(dataimg): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type','multipart/form-data');

		return this._http.post(this.url+'usr_upimage', dataimg);
	} 

	//--Obtener datos del localstorage--//
	getIdentity(){
		let identity = JSON.parse(localStorage.getItem('currentUser')); // convertirlo a un objeto javascript usable

		if(identity && identity != "undefined"){
			this.identity = identity;
		}else{
			this.identity = null;
		}

		return this.identity;
	}
	 
	//--Obtener token de local storage--//
	getToken(){
		let token = localStorage.getItem('token');

		if(token && token != "undefined"){
			this.token = token;
		}else{
			this.token = null;
		}

		return this.token;
	}

	// Obtener todos los usuarios
	getUsers(): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type', 'application/json');

		return this._http.get<Users>(this.url+'usr_showg', {headers: headers});
	}

	// Obtener los usuarios habilitados
	getUsersl(): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type', 'application/json');

		return this._http.get<Users>(this.url+'usr_showsl', {headers: headers});
	}

	// Obtener todos los tipos de usuarios
	getTypePeople(): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type', 'application/json');

		return this._http.get(this.url+'usr_showtp', {headers: headers});
	}

	// Obtener usuarios por tipo de perfil
	getUserspf(perfil): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type', 'application/json');

		return this._http.get(this.url+'usr_showt/'+perfil, {headers: headers});
	}

	// Obtener todos los perfiles de usuarios
	getProfile(): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type', 'application/json');

		return this._http.get(this.url+'usr_showpf', {headers: headers});
	}

	// Obtener todos los usuarios
	getUser(idu): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type', 'application/json');

		return this._http.get<Users>(this.url+'usr_show/'+idu, {headers: headers});
	}

	// Obtener todos los usuarios
	getIdUser(tp, idu): Observable<any>{
		let headers = new HttpHeaders().set('Content-Type', 'application/json');

		return this._http.get<Users>(this.url+'usr_showidu/'+tp+'/'+idu, {headers: headers});
	}
}